import React from 'react';
import styled from '@emotion/styled';
import { mediaQueries } from 'components/mediaQueries';
import { MiniArticleCard as MiniArticleCardType } from 'data/global/types';
import { MiniArticleCard } from 'components/Cards/MiniArticleCard/MiniArticleCard';
import { TrackedComponent, withScrollTracking } from 'tracking';

type Props = {
  articles: MiniArticleCardType[];
  componentNameForTracking?: string;
};

export const MiniArticleCards = ({
  articles,
  componentNameForTracking,
}: Props) => {
  if (!articles.length) {
    return null;
  }

  return (
    <TrackingWrapperList
      avroIdentifier={TrackedComponent.MiniArticleCards}
      preAvroIdentifier={
        componentNameForTracking || TrackedComponent.MiniArticleCards
      }
    >
      {articles.map((article: MiniArticleCardType, index: number) => {
        if (index < 4)
          return (
            <li key={index}>
              <MiniArticleCard article={article} />
            </li>
          );
      })}
    </TrackingWrapperList>
  );
};

const List = styled.ul`
  display: grid;
  grid-row-gap: 20px;
  ${mediaQueries.tablet} {
    grid-row-gap: 15px;
    min-width: 100%;
    width: 100%;
  }
  ${mediaQueries.desktop} {
    grid-auto-columns: minmax(0, 1fr);
    grid-auto-flow: column;
    grid-column-gap: 20px;
    min-width: 100%;
    max-width: 1200px;
    overflow: hidden;
  }
`;

const TrackingWrapperList = withScrollTracking(List);
